import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { tr } from "../lib/i18n";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString() : "");

// Vehicle page → Social Posts: drafts, scheduled, posted (with links), failed (plain error), who made / posted each.
export default function SocialPostsTab({ vehicleId }) {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get(`/social/suggestions/by-vehicle/${vehicleId}`).then((r) => setItems(r.data.items)).catch(() => setItems([]));
  }, [vehicleId]);
  if (!items) return <div className="panel p-6 mt-6 text-sm" data-testid="social-posts-loading">{tr("x.loading")}</div>;
  if (!items.length) return <div className="panel p-6 mt-6 text-sm" data-testid="social-posts-empty">{tr("sp.empty")}</div>;
  return (
    <div className="panel mt-6 divide-y divide-[var(--line)]" data-testid="social-posts-tab">
      {items.map((s) => (
        <div key={s.id} className="p-4 flex flex-wrap items-start gap-3 justify-between" data-testid={`social-post-${s.id}`}>
          <div className="min-w-0 space-y-1">
            <span className={`text-xs font-semibold px-2 py-0.5 rounded-full border ${s.view_status === "failed" ? "border-red-500 text-red-700" : "border-[var(--line)]"}`}
              data-testid={`social-post-status-${s.id}`}>{tr(`sp.status_${s.view_status /* i18n-keys: draft,scheduled,posted,failed,skipped,posting,paused,needs_review */}`)}</span>
            <div className="text-sm">{(s.caption || "").slice(0, 140)}</div>
            <div className="text-xs opacity-75">
              {tr("sp.created_by", { p0: s.created_by_name || tr("sp.automatic"), p1: fmt(s.created_at) })}
              {s.posted_by ? ` · ${tr("sp.posted_by", { p0: s.posted_by, p1: fmt(s.posted_at) })}` : ""}
              {s.scheduled_at && s.status === "scheduled" ? ` · ${tr("sg.scheduled_for", { p0: fmt(s.scheduled_at) })}` : ""}
            </div>
            {s.view_status === "failed" && <div className="text-sm text-red-700" data-testid={`social-post-error-${s.id}`}>{s.post_error}</div>}
          </div>
          <div className="flex flex-col gap-1 text-sm">
            {(s.posts || []).map((p) => (
              <a key={p.platform} href={p.permalink} target="_blank" rel="noopener noreferrer" className="underline" data-testid={`social-post-link-${s.id}-${p.platform}`}>
                {p.platform === "facebook" ? tr("sp.view_facebook") : tr("sg.view_post")}{p.mock ? ` (${tr("sp.test")})` : ""}
              </a>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
